var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M12 1C5.923 1 1 5.923 1 12s4.923 11 11 11 11-4.923 11-11S18.077 1 12 1zm3.548 7.452a1.419 1.419 0 11-1.419 1.419c0-.785.634-1.42 1.42-1.42zm-7.096 0c.785 0 1.419.634 1.419 1.419a1.418 1.418 0 11-2.839 0c0-.785.635-1.42 1.42-1.42zM17.092 16A6.607 6.607 0 0112 18.386 6.61 6.61 0 016.908 16c-.603-.723.488-1.628 1.091-.91A5.182 5.182 0 0012 16.962a5.197 5.197 0 004-1.871c.595-.719 1.69.186 1.092.909z"
  }))));
}

export default SvgSmile;